import { render, staticRenderFns } from "./x-select.vue?vue&type=template&id=109f0a4a&"
import script from "./x-select.vue?vue&type=script&lang=js&"
export * from "./x-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('109f0a4a', component.options)
    } else {
      api.reload('109f0a4a', component.options)
    }
    module.hot.accept("./x-select.vue?vue&type=template&id=109f0a4a&", function () {
      api.rerender('109f0a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-select.vue"
export default component.exports